import { jsx as i } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { Separator as n } from "@radix-ui/react-separator";
import { twMerge as l } from "tailwind-merge";
const x = e(
  (r, o) => {
    const { className: a = "", ...t } = r;
    return /* @__PURE__ */ i(
      n,
      {
        ref: o,
        className: l(
          "radix-orientation-horizontal:h-px radix-orientation-horizontal:w-full radix-orientation-vertical:h-full radix-orientation-vertical:w-px bg-gray-100",
          a
        ),
        ...t
      }
    );
  }
);
export {
  x as Separator
};
